import type { ReactNode } from "react";

import type { DesignSystemElementProps, DesignSystemRef } from "./contracts/dom";

export type DividerProps = DesignSystemElementProps<"hr"> & DesignSystemRef<HTMLHRElement>;

export function Divider({ ref, ...nativeProps }: DividerProps): ReactNode {
  return <hr {...nativeProps} ref={ref} className="w-full border-t-0 border-b border-border-default" />;
}
